import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Mail } from 'lucide-react';
import { toast } from 'sonner';

const ContactSection = () => {
  const { t, language } = useLanguage();
  const [form, setForm] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Redirect to email with pre-filled content
    const subject = encodeURIComponent(`Contacto desde CR Home - ${form.name}`);
    const body = encodeURIComponent(`Nombre: ${form.name}\nEmail: ${form.email}\n\nMensaje:\n${form.message}`);
    window.location.href = `mailto:admin@crhome.mx?subject=${subject}&body=${body}`;
    
    toast.success(t.contact.successMessage);
    setForm({ name: '', email: '', message: '' });
  };

  return (
    <section id="contact" className="py-32 bg-neutral-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-amber-600 text-sm font-light tracking-[0.3em] uppercase mb-4">
            {language === 'es' ? 'Contacto' : 'Contact'}
          </p>
          <h2 className="text-5xl md:text-6xl font-light text-neutral-900 mb-4 tracking-tight">
            {language === 'es' ? 'Contacto' : 'Contact'}
          </h2>
          <p className="text-xl text-neutral-500 font-light italic">
            {language === 'es' ? 'Hablemos de tu proyecto' : "Let's talk about your project"}
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-12">
          {/* Email Contact Card */}
          <Card className="shadow-2xl border-0 bg-white">
            <CardContent className="p-12">
              <div className="flex flex-col items-center justify-center text-center space-y-6">
                <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center">
                  <Mail className="h-10 w-10 text-amber-700" />
                </div>
                <div>
                  <h3 className="text-2xl font-light text-neutral-900 mb-3">
                    {language === 'es' ? 'Envíanos un correo' : 'Send us an email'}
                  </h3>
                  <a 
                    href="mailto:admin@crhome.mx" 
                    className="text-2xl text-amber-600 hover:text-amber-700 transition-colors duration-200 font-light"
                  >
                    admin@crhome.mx
                  </a>
                </div>
                <p className="text-neutral-600 max-w-md font-light">
                  {language === 'es' 
                    ? 'Comparte tu visión con nosotros y transformemos juntos tu espacio.'
                    : 'Share your vision with us and let\'s transform your space together.'}
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Contact Form */}
          <Card className="shadow-2xl border-0">
            <CardHeader>
              <CardTitle className="text-2xl font-light text-center">
                {language === 'es' ? 'O completa este formulario' : 'Or fill out this form'}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="space-y-2">
                  <Label htmlFor="name">{t.contact.name}</Label>
                  <Input
                    id="name"
                    value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                    required
                    className="border-neutral-300"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="email">{t.contact.email}</Label>
                  <Input
                    id="email"
                    type="email"
                    value={form.email}
                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                    required
                    className="border-neutral-300"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="message">{t.contact.message}</Label>
                  <Textarea
                    id="message"
                    value={form.message}
                    onChange={(e) => setForm({ ...form, message: e.target.value })}
                    required
                    rows={5}
                    className="border-neutral-300 resize-none"
                  />
                </div>
                <Button type="submit" className="w-full bg-amber-600 hover:bg-amber-700 text-white py-6">
                  {t.contact.sendButton}
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;